


























































import Vue from 'vue'
import Presenter, { IPresenter } from './presenter'
import Button from '@/components/shared/atoms/Button/Button'
import Checkbox from '@/components/shared/atoms/Checkbox'
import TextLink from '@/components/shared/atoms/TextLink'
import { INQUIRY_CONTENTS } from '@/const'
import { IInquirySeed } from '@/entities/Inquiry'

interface IData {
  isAgree: boolean
}

export default Vue.extend({
  components: {
    Button,
    Checkbox,
    TextLink
  },
  props: {
    fields: {
      type: Object as () => IInquirySeed,
      required: true
    }
  },
  data(): IData {
    return {
      isAgree: false
    }
  },
  computed: {
    presenter(): IPresenter {
      return Presenter({
        profileRepository: this.$profileRepository
      })
    },
    categoryName(): string {
      if (!this.fields.category) return ''
      return INQUIRY_CONTENTS[this.fields.category].name
    }
  },
  methods: {
    submit() {
      this.$emit('success')
    }
  }
})
